import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#1A2332] to-[#2A3342] text-white py-16">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* About */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/9c9ac816b13094cc8d77dd2c904cea49/d34cd039686a7dceae081bba4b9a7591.png" 
                alt="Stichting IPN Logo" 
                className="h-12 w-auto object-contain animate-pulse"
                style={{ animationDuration: '3s' }}
              />
              <div className="flex flex-col animate-pulse" style={{ animationDuration: '3s' }}>
                <span className="text-xl font-bold">Stichting IPN</span>
                <span className="text-xs text-gray-400">Interpreters & Professionals Network</span>
              </div>
            </div>
            <p className="text-gray-300 leading-relaxed mb-6">
              {t('footer.about.text')}
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#C9A961] transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#C9A961] transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#C9A961] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#C9A961] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-gray-300 hover:text-[#C9A961] transition-colors cursor-pointer">
                  {t('nav.home')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-300 hover:text-[#C9A961] transition-colors cursor-pointer">
                  {t('nav.about')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('directory')} className="text-gray-300 hover:text-[#C9A961] transition-colors cursor-pointer">
                  {t('nav.directory')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('knowledge')} className="text-gray-300 hover:text-[#C9A961] transition-colors cursor-pointer">
                  {t('nav.knowledge')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('impact')} className="text-gray-300 hover:text-[#C9A961] transition-colors cursor-pointer">
                  {t('nav.impact')}
                </button>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-lg font-bold mb-4">{t('footer.newsletter')}</h4>
            <p className="text-gray-300 text-sm mb-4">
              Haberler ve güncellemeler için abone olun
            </p>
            <form className="space-y-3">
              <input
                type="email"
                placeholder={t('footer.newsletter.placeholder')}
                className="w-full px-4 py-2 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C9A961] text-white placeholder-gray-400 text-sm"
              />
              <button
                type="submit"
                className="w-full px-4 py-2 bg-[#C9A961] text-[#1A2332] rounded-lg font-semibold hover:bg-[#B89851] transition-colors text-sm whitespace-nowrap cursor-pointer"
              >
                {t('footer.newsletter.button')}
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            {t('footer.copyright')}
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-gray-400 hover:text-[#C9A961] transition-colors text-sm cursor-pointer">
              {t('footer.privacy')}
            </a>
            <a href="#" className="text-gray-400 hover:text-[#C9A961] transition-colors text-sm cursor-pointer">
              {t('footer.terms')}
            </a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#C9A961] transition-colors text-sm cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
